import type { PostgrestError } from '@supabase/supabase-js';
import { supabase } from './supabaseClient';
import type { VocabWord } from '../types/vocab';

interface HardTermRow {
  id: string;
  word: string;
  definition: string;
  similar_words_category?: string | null;
  similar_words?: string | null;
}

const PAGE_SIZE = 500;
const selectColumns = 'id, word, definition, similar_words_category, similar_words';

const mapRow = (row: HardTermRow): VocabWord => ({
  Word: row.word || '',
  Definition: row.definition || '',
  'Similar words category': row.similar_words_category ?? '',
  'Similar words ': row.similar_words ?? '',
  ID: row.id,
  source: 'hard_terms',
  isCustom: false
});

export async function fetchAllHardTerms(
  pageSize = PAGE_SIZE
): Promise<{ data: VocabWord[]; error: PostgrestError | null }> {
  const aggregated: VocabWord[] = [];
  let page = 0;

  while (true) {
    const from = page * pageSize;
    const to = from + pageSize - 1;
    const { data, error } = await supabase
      .from('hard_terms')
      .select(selectColumns)
      .order('word', { ascending: true })
      .range(from, to);

    if (error) return { data: aggregated, error };
    if (!data || data.length === 0) break;

    aggregated.push(...data.map(mapRow));
    if (data.length < pageSize) break;
    page += 1;
  }

  return { data: aggregated, error: null };
}


